import * as _ from 'lodash'
import { isEmpty } from 'ramda'
import * as moment from 'moment'
import { ViolationDetail, Speed, AverageSpeed, Entry, SpotSpeed } from "../types";

export const transformTrafficCongestionData = (response: any, timeKey: any) => {
    // response = trafficCongestion; // for testing

    if (!response || isEmpty(response) || response.length === 0) {
        return {}
    }

    let seriesData = [];

    let pointInterval = 3600000;

    if (response.length > 1) {
        pointInterval = Number(response[1].ts) - Number(response[0].ts);
    }

    for (let i = 0; i < response.length; i++) {
        const key = response[i];
        const xVal = key.ts;

        const yVal = key.congestion_measure;

        const point = {
            x: xVal, y: yVal
        };

        seriesData.push(point);
    }

    let name = 'All Day';
    if (timeKey === 'allDay') {
        name = 'All Day';
    } else if (timeKey === 'sixHours') {
        name = 'Last 6h';
    } else if (timeKey === 'twelveHours') {
        name = 'Last 12h';
    }

    const areaChartTrafficCongestion = {
        series: [{
            name,
            data: seriesData,
            fillColor: "#D0EFFA",
            lineColor: "#55cfff",
            // badgeBackgroundColor: '#66b20c',
            visible: true,
            pointInterval: pointInterval,
            animation: false,
            zIndex: 1
        }]
    };

    return {
        areaChart: areaChartTrafficCongestion
    };

};

export const transformTotalViolationsData = (response: any) => {
    // response = totalViolations; // for testing

    if (!response || isEmpty(response) || response.length === 0) {
        return {}
    }

    let seriesData = [];
    const pointInterval = Number(response[1].ts) - Number(response[0].ts);




    const today = moment();

    for (let i = 0; i < response.length; i++) {
        const key = response[i];

        const xVal = key.ts;

        const yVal = key.violations_count;

        const point = {
            x: xVal, y: yVal
        };

        seriesData.push(point);
    }

    const totalViolationCount = _.reduce(response, function (sum, n) {
        if (today.isSame(n.ts, 'd')) {
            return sum + n.violations_count;
        } else {
            return 0;
        }
    }, 0);


    const areaChartTotalViolations = {
        series: [{
            name: 'Violations',
            data: seriesData,
            fillColor: "#F5DFDF",
            lineColor: "#ff6060",
            //  badgeBackgroundColor: '#66b20c',
            visible: true,
            pointInterval: pointInterval,
            animation: false,
            zIndex: 1
        }]
    };

    return {
        areaChart: areaChartTotalViolations,
        totalViolationCount
    };


};


export const transformTurnViolationsData = (response: any) => {
    // response = turnViolations; // for testing

    if (isEmpty(response)
        || !response.hasOwnProperty('total_violators')
        || !response.hasOwnProperty('total_non_violators')) {
        return {}
    }

    const totalViolators = response['total_violators'];
    const totalNonViolators = response['total_non_violators'];

    const total = totalViolators + totalNonViolators;
    const name = '<b>' + total + '</b><br>Vehicles';

    const violatorsPercentage = Math.round((totalViolators * 100) / total);

    const donutChartTurnViolations = {
        series: [{
            type: 'pie',
            name,
            innerSize: '70%',
            data: [
                // ['Total', totalNonViolators],
                // ['Queue Jumping', totalViolators],
                {
                    name: totalNonViolators,
                    y: totalNonViolators,
                    color: '#82ca9c',
                    dataLabels: {
                        enabled: true
                    }
                },
                {
                    name: totalViolators,
                    y: totalViolators,
                    color: '#ff6060',
                    dataLabels: {
                        enabled: true
                    }
                }
            ]
        }],
        title: {
            text: name,
            align: 'center',
            style: {
                "fontSize": "16px"
            },
            verticalAlign: 'middle',
            y: -40,
            x: 25
        },
    };

    return {
        violatorsPercentage,
        chart: donutChartTurnViolations
    };
};

export const transformViolationsData = (response: any) => {
    let groupViolations = {};
    let violationsArray: any[] = [];

    if (isEmpty(response) || response.length === 0 || !response) {
        return {
            violationsHistory: groupViolations,
            recentViolations: violationsArray,
            rawData: response
        };
    }

    response.forEach((violation: any) => {

        let cutLane = {};
        let runningredlight = {};
        let trespass_zebra = {};
        let wrongturn = {};
        let wrongway = {};
        let seatbelt = {};
        let cellphone = {};
        let speed = {};
        let spotspeed = {};

        let violationDateTime = moment(violation.ALPR.epoch_time).format('hh:mm:ss.SS A, DD/MM/YYYY');
        let violationDate = moment(violation.ALPR.epoch_time).format('DD MMMM');

        if (violation.hasOwnProperty('violations')) {

            if (violation.violations.hasOwnProperty('seatbelt')) {
                let image = '';
                let video = '';
                const id = violation.id + '_seatbelt';
                if (violation.violations.seatbelt.media) {
                    image = violation.violations.seatbelt.media.images.c.path;
                    video = violation.violations.seatbelt.media.videos[0].path;
                }
                seatbelt = {
                    id,
                    violationType: 'seatbelt',
                    violationDate: violationDateTime,
                    violationImage: image,
                    violationVideoUrl: video,
                }
            }
            if (violation.violations.hasOwnProperty('cellphone')) {
                let image = '';
                let video = '';
                const id = violation.id + '_cellphone';
                if (violation.violations.cellphone.media) {
                    image = violation.violations.cellphone.media.images.c.path;
                    video = violation.violations.cellphone.media.videos[0].path;
                }
                cellphone = {
                    id,
                    violationType: 'cellphone',
                    violationDate: violationDateTime,
                    violationImage: image,
                    violationVideoUrl: video,
                }
            }
            if (violation.violations.hasOwnProperty('wrongturn')) {
                let image = '';
                let video = '';
                const id = violation.id + '_wrongturn';
                if (violation.violations.wrongturn.media) {
                    image = violation.violations.wrongturn.media.images.c.path;
                    video = violation.violations.wrongturn.media.videos[0].path;
                }
                wrongturn = {
                    id,
                    violationType: 'wrongturn',
                    violationDate: violationDateTime,
                    violationImage: image,
                    violationVideoUrl: video,
                }
            }
            if (violation.violations.hasOwnProperty('wrongway')) {
                let image = '';
                let video = '';
                const id = violation.id + '_wrongway';
                if (violation.violations.wrongway.media) {
                    image = violation.violations.wrongway.media.images.c.path;
                    video = violation.violations.wrongway.media.videos[0].path;
                }
                wrongway = {
                    id,
                    violationType: 'wrongway',
                    violationDate: violationDateTime,
                    violationImage: image,
                    violationVideoUrl: video,
                }
            }
            if (violation.violations.hasOwnProperty('cutlane')) {
                let image = '';
                let video = '';
                const id = violation.id + '_cutlane';
                if (violation.violations.cutlane.media) {
                    image = violation.violations.cutlane.media.images.c.path;
                    video = violation.violations.cutlane.media.videos[0].path;
                }
                cutLane = {
                    id,
                    violationType: 'cutlane',
                    violationDate: violationDateTime,
                    violationImage: image,
                    violationVideoUrl: video,
                }
            }

            if (violation.violations.hasOwnProperty('runningredlight')) {
                let image = '';
                let video = '';
                const id = violation.id + '_runningredlight';
                if (violation.violations.runningredlight.media) {
                    image = violation.violations.runningredlight.media.images.c.path;
                    video = violation.violations.runningredlight.media.videos[0].path;
                }
                runningredlight = {
                    id,
                    violationType: 'runningredlight',
                    violationDate: violationDateTime,
                    violationImage: image,
                    violationVideoUrl: video,
                }
            }

            if (violation.violations.hasOwnProperty('trespass_zebra')) {
                let image = '';
                let video = '';
                const id = violation.id + '_trespass_zebra';
                if (violation.violations.trespass_zebra.media) {
                    image = violation.violations.trespass_zebra.media.images.c.path;
                    video = violation.violations.trespass_zebra.media.videos[0].path;
                }
                trespass_zebra = {
                    id,
                    violationType: 'trespass_zebra',
                    violationDate: violationDateTime,
                    violationImage: image,
                    violationVideoUrl: video,
                }
            }
            if (violation.violations.hasOwnProperty('speed')) {
                let image = '';
                let video = '';
                const id = violation.id + '_speed';
                if (violation.violations.speed.media) {
                    image = violation.violations.speed.media.images.c.path;
                    video = violation.violations.speed.media.videos[0].path;
                }
                let entry: Entry = {
                    time: moment(1634820135021).format('hh:mm:ss.SS A, DD/MM/YYYY'),
                    id: "A"
                }
                let exit: Entry = {
                    time: moment(1634820145021).format('hh:mm:ss.SS A, DD/MM/YYYY'),
                    id: "B"
                }
                let averageSpeed: AverageSpeed = {
                    entry: entry,
                    exit: exit,
                    value: 10,
                    unit: "Km/h",
                    distance: 10,
                    ts_diff: 10,
                }
                let spotSpeed: SpotSpeed = {
                    value: 10,
                    unit: "Km/h",
                    id: "A",
                    entry: entry,
                    exit: exit,
                }
                if (violation.hasOwnProperty('speed')){
                    if (violation.speed.hasOwnProperty('avgspeed')){
                        averageSpeed.value = violation.speed.avgspeed.value;
                        averageSpeed.unit = violation.speed.avgspeed.unit;
                        averageSpeed.distance = violation.speed.avgspeed.distance;
                        averageSpeed.ts_diff = violation.speed.avgspeed.ts_diff;
                        averageSpeed.entry.time = moment(violation.speed.avgspeed.entry.timestamp).format('hh:mm:ss.SS A, DD/MM/YYYY');
                        averageSpeed.entry.id = violation.speed.avgspeed.entry.id;
                        averageSpeed.exit.time = moment(violation.speed.avgspeed.exit.timestamp).format('hh:mm:ss.SS A, DD/MM/YYYY');
                        averageSpeed.exit.id = violation.speed.avgspeed.exit.id;
                    } 
                }
                let speedInfo: Speed = {
                    avgSpeed: averageSpeed,
                    spotSpeed: spotSpeed
                }
                speed = {
                    id,
                    violationType: 'speed',
                    violationDate: violationDateTime,
                    violationImage: image,
                    violationVideoUrl: video,
                    speedInfo: speedInfo
                }
            }
            if (violation.violations.hasOwnProperty('spotspeed')) {
                let image = '';
                let video = '';
                const id = violation.id + '_spotspeed';
                if (violation.violations.spotspeed.media) {
                    image = violation.violations.spotspeed.media.images.c.path;
                    video = violation.violations.spotspeed.media.videos[0].path;
                }
                let entry: Entry = {
                    time: moment(1634820135021).format('hh:mm:ss.SS A, DD/MM/YYYY'),
                    id: "A"
                }
                let exit: Entry = {
                    time: moment(1634820145021).format('hh:mm:ss.SS A, DD/MM/YYYY'),
                    id: "B"
                }
                let averageSpeed: AverageSpeed = {
                    entry: entry,
                    exit: exit,
                    value: 10,
                    unit: "Km/h",
                    distance: 10,
                    ts_diff: 10,
                }
                let spotSpeed: SpotSpeed = {
                    value: 10,
                    unit: "Km/h",
                    id: "A",
                    entry: entry,
                    exit: exit,
                }
                if (violation.hasOwnProperty('speed')){
                     if(violation.speed.hasOwnProperty('spotspeed')) {
                        spotSpeed.value = violation.speed.spotspeed.value;
                        spotSpeed.unit = violation.speed.spotspeed.unit;
                        spotSpeed.id = violation.speed.spotspeed.id;
                        if(violation.speed.spotspeed.hasOwnProperty('entry')){
                            spotSpeed.entry.time = moment(violation.speed.spotspeed.entry.timestamp).format('hh:mm:ss.SS A, DD/MM/YYYY');
                        }
                        if(violation.speed.spotspeed.hasOwnProperty('exit')){
                            spotSpeed.exit.time = moment(violation.speed.spotspeed.exit.timestamp).format('hh:mm:ss.SS A, DD/MM/YYYY');
                        }
                    }
                }
                let speedInfo: Speed = {
                    avgSpeed: averageSpeed,
                    spotSpeed: spotSpeed
                }
                spotspeed = {
                    id,
                    violationType: 'spotspeed',
                    violationDate: violationDateTime,
                    violationImage: image,
                    violationVideoUrl: video,
                    speedInfo: speedInfo
                }
            }
        }

        if (violation.hasOwnProperty('ALPR')) {
            const result = violation.ALPR.results[0];

            const plate = result.plate;
            const vehicle = result.vehicle;
            const carType = vehicle.body_type[0].name; //sedan-compact
            const color = vehicle.color[0].name; // silver-gray
            const vehicleSummary = plate + ' | Type ' + carType + ' | Color ' + color;

            const violationDetail: ViolationDetail = {
                violationDate: violationDateTime,
                violationType: '',
                violationImage: '',
                plateNumber: plate,
                carType,
                color,
                colorString: color,
                videoUrl: violation.videos,
                plateImageUrl: violation.ALPR_cropped_image,
                imageUrl: violation.ALPR_full_image,
            };

            if (!groupViolations.hasOwnProperty(violationDate)) {
                groupViolations = {
                    ...groupViolations,
                    [violationDate]: []
                };
            }

            if (Object.keys(cutLane).length > 0) {
                cutLane = {
                    ...cutLane,
                    vehicleSummary,
                    violationDetail
                };

                violationsArray.push(cutLane);
                groupViolations[violationDate].push(cutLane);
            }

            if (Object.keys(runningredlight).length > 0) {
                runningredlight = {
                    ...runningredlight,
                    vehicleSummary,
                    violationDetail
                };

                violationsArray.push(runningredlight);
                groupViolations[violationDate].push(runningredlight);
            }

            if (Object.keys(trespass_zebra).length > 0) {
                trespass_zebra = {
                    ...trespass_zebra,
                    vehicleSummary,
                    violationDetail
                };

                violationsArray.push(trespass_zebra);
                groupViolations[violationDate].push(trespass_zebra);
            }

            if (Object.keys(wrongturn).length > 0) {
                wrongturn = {
                    ...wrongturn,
                    vehicleSummary,
                    violationDetail
                };

                violationsArray.push(wrongturn);
                groupViolations[violationDate].push(wrongturn);
            }
            if (Object.keys(wrongway).length > 0) {
                wrongway = {
                    ...wrongway,
                    vehicleSummary,
                    violationDetail
                };
                violationsArray.push(wrongway);
                groupViolations[violationDate].push(wrongway);
            }
            if (Object.keys(cellphone).length > 0) {
                cellphone = {
                    ...cellphone,
                    vehicleSummary,
                    violationDetail
                };

                violationsArray.push(cellphone);
                groupViolations[violationDate].push(cellphone);
            }
            if (Object.keys(seatbelt).length > 0) {
                seatbelt = {
                    ...seatbelt,
                    vehicleSummary,
                    violationDetail
                };

                violationsArray.push(seatbelt);
                groupViolations[violationDate].push(seatbelt);
            }
            if (Object.keys(speed).length > 0) {
                speed = {
                    ...speed,
                    vehicleSummary,
                    violationDetail
                };

                violationsArray.push(speed);
                groupViolations[violationDate].push(speed);
            }
            if (Object.keys(spotspeed).length > 0) {
                spotspeed = {
                    ...spotspeed,
                    vehicleSummary,
                    violationDetail
                };

                violationsArray.push(spotspeed);
                groupViolations[violationDate].push(spotspeed);
            }
        }


    });

    const keys = Object.keys(groupViolations).reverse();
    keys.forEach(key => {
        groupViolations[key].reverse();
    });

    return {
        violationsHistory: groupViolations,
        recentViolations: violationsArray.reverse(),
        rawData: response
    };

};

export const transformRecentViolationsEventData = (response: any) => {
    // response = recentViolations; // for testing
    if (!response || isEmpty(response) || response.length === 0) {
        return {}
    }
    // let groupViolations = {};
    let violationsArray: any[] = [];

    let cutLane = {};
    let runningredlight = {};
    let trespass_zebra = {};
    let wrongturn = {};
    let wrongway = {};
    let seatbelt = {};
    let cellphone = {};
    let speed = {};
    let spotspeed = {};

    const violationDateTime = moment(response.ALPR.epoch_time).format('hh:mm:ss.SS A, DD/MM/YYYY');
    // const violationDate =  moment(response.ALPR.epoch_time).format('DD MMMM');
    if (response.hasOwnProperty('violations')) {
        if (response.violations.hasOwnProperty('cutlane')) {
            let image = '';
            let video = '';
            const id = response.id + '_cutlane';
            if (response.violations.cutlane.media) {
                image = response.violations.cutlane.media.images.c.path;
                video = response.violations.cutlane.media.videos[0].path;
            }
            cutLane = {
                id,
                violationType: 'cutlane',
                violationDate: violationDateTime,
                violationImage: image,
                violationVideoUrl: video,
            }
        }

        if (response.violations.hasOwnProperty('runningredlight')) {
            let image = '';
            let video = '';
            const id = response.id + '_runningredlight';
            if (response.violations.runningredlight.media) {
                image = response.violations.runningredlight.media.images.c.path;
                video = response.violations.runningredlight.media.videos[0].path;

            }
            runningredlight = {
                id,
                violationType: 'runningredlight',
                violationDate: violationDateTime,
                violationImage: image,
                violationVideoUrl: video,
            }
        }

        if (response.violations.hasOwnProperty('trespass_zebra')) {
            let image = '';
            let video = '';
            const id = response.id + '_trespass_zebra';
            if (response.violations.trespass_zebra.media) {
                image = response.violations.trespass_zebra.media.images.c.path;
                video = response.violations.trespass_zebra.media.videos[0].path;
            }
            trespass_zebra = {
                id,
                violationType: 'trespass_zebra',
                violationDate: violationDateTime,
                violationImage: image,
                violationVideoUrl: video,
            }
        }
        if (response.violations.hasOwnProperty('wrongturn')) {
            let image = '';
            let video = '';
            const id = response.id + '_wrongturn';
            if (response.violations.wrongturn.media) {
                image = response.violations.wrongturn.media.images.c.path;
                video = response.violations.wrongturn.media.videos[0].path;
            }
            wrongturn = {
                id,
                violationType: 'wrongturn',
                violationDate: violationDateTime,
                violationImage: image,
                violationVideoUrl: video,
            }
        }
        if (response.violations.hasOwnProperty('wrongway')) {
            let image = '';
            let video = '';
            const id = response.id + '_wrongway';
            if (response.violations.wrongway.media) {
                image = response.violations.wrongway.media.images.c.path;
                video = response.violations.wrongway.media.videos[0].path;
            }
            wrongway = {
                id,
                violationType: 'wrongway',
                violationDate: violationDateTime,
                violationImage: image,
                violationVideoUrl: video,
            }
        }
        if (response.violations.hasOwnProperty('seatbelt')) {
            let image = '';
            let video = '';
            const id = response.id + '_seatbelt';
            if (response.violations.seatbelt.media) {
                image = response.violations.seatbelt.media.images.c.path;
                video = response.violations.seatbelt.media.videos[0].path;
            }
            seatbelt = {
                id,
                violationType: 'seatbelt',
                violationDate: violationDateTime,
                violationImage: image,
                violationVideoUrl: video,
            }
        }
        if (response.violations.hasOwnProperty('cellphone')) {
            let image = '';
            let video = '';
            const id = response.id + '_cellphone';
            if (response.violations.cellphone.media) {
                image = response.violations.cellphone.media.images.c.path;
                video = response.violations.cellphone.media.videos[0].path;
            }
            cellphone = {
                id,
                violationType: 'cellphone',
                violationDate: violationDateTime,
                violationImage: image,
                violationVideoUrl: video,
            }
        }
        if (response.violations.hasOwnProperty('speed')) {
            let image = '';
            let video = '';
            const id = response.id + '_speed';
            if (response.violations.speed.media) {
                image = response.violations.speed.media.images.c.path;
                video = response.violations.speed.media.videos[0].path;
            }
            speed = {
                id,
                violationType: 'speed',
                violationDate: violationDateTime,
                violationImage: image,
                violationVideoUrl: video,
            }
        }
        if (response.violations.hasOwnProperty('spotspeed')) {
            let image = '';
            let video = '';
            const id = response.id + '_spotspeed';
            if (response.violations.spotspeed.media) {
                image = response.violations.spotspeed.media.images.c.path;
                video = response.violations.spotspeed.media.videos[0].path;
            }
            spotspeed = {
                id,
                violationType: 'spotspeed',
                violationDate: violationDateTime,
                violationImage: image,
                violationVideoUrl: video,
            }
        }

    }

    if (response.hasOwnProperty('ALPR')) {
        const result = response.ALPR.results[0];

        const plate = result.plate;
        const vehicle = result.vehicle;
        const carType = vehicle.body_type[0].name; //sedan-compact

        const color = vehicle.color[0].name; // silver-gray

        const vehicleSummary = plate + ' | Type ' + carType + ' | Color ' + vehicle.color[0].name;

        const violationDetail: ViolationDetail = {
            violationDate: violationDateTime,
            violationType: '',
            violationImage: '',
            plateNumber: plate,
            carType,
            color,
            colorString: color,
            videoUrl: response.videos,
            plateImageUrl: response.ALPR_cropped_image,
            imageUrl: response.ALPR_full_image
        };

        if (Object.keys(cutLane).length > 0) {
            cutLane = {
                ...cutLane,
                vehicleSummary,
                violationDetail
            };

            violationsArray.push(cutLane);
        }

        if (Object.keys(runningredlight).length > 0) {
            runningredlight = {
                ...runningredlight,
                vehicleSummary,
                violationDetail
            };

            violationsArray.push(runningredlight);
        }

        if (Object.keys(trespass_zebra).length > 0) {
            trespass_zebra = {
                ...trespass_zebra,
                vehicleSummary,
                violationDetail
            };

            violationsArray.push(trespass_zebra);
        }
        if (Object.keys(wrongturn).length > 0) {
            wrongturn = {
                ...wrongturn,
                vehicleSummary,
                violationDetail
            };

            violationsArray.push(wrongturn);
        }
        if (Object.keys(wrongway).length > 0) {
            wrongway = {
                ...wrongway,
                vehicleSummary,
                violationDetail
            };

            violationsArray.push(wrongway);
        }
        if (Object.keys(seatbelt).length > 0) {
            seatbelt = {
                ...seatbelt,
                vehicleSummary,
                violationDetail
            };

            violationsArray.push(seatbelt);
        }
        if (Object.keys(cellphone).length > 0) {
            cellphone = {
                ...cellphone,
                vehicleSummary,
                violationDetail
            };

            violationsArray.push(cellphone);
        }
        if (Object.keys(speed).length > 0) {
            speed = {
                ...speed,
                vehicleSummary,
                violationDetail
            };

            violationsArray.push(speed);
        }
        if (Object.keys(spotspeed).length > 0) {
            spotspeed = {
                ...spotspeed,
                vehicleSummary,
                violationDetail
            };

            violationsArray.push(spotspeed);
        }
    }
    return violationsArray[0] ? violationsArray[0] : {}

};

// @ts-ignore
const trafficCongestion = [
    {
        "ts": 1535987473, //GMT seconds since epoch
        "congestion_measure": 100 //INT unique count
    },

    {
        "ts": 1535987474, //GMT seconds since epoch
        "congestion_measure": 80 //INT unique count
    },

    {
        "ts": 1535987475, //GMT seconds since epoch
        "congestion_measure": 60 //INT unique count
    },

    {
        "ts": 1535987476, //GMT seconds since epoch
        "congestion_measure": 120 //INT unique count
    },

    {
        "ts": 1535987477, //GMT seconds since epoch
        "congestion_measure": 150 //INT unique count
    },

    {
        "ts": 1535987478, //GMT seconds since epoch
        "congestion_measure": 200 //INT unique count
    },

    {
        "ts": 1535987479, //GMT seconds since epoch
        "congestion_measure": 123 //INT unique count
    },
];

// @ts-ignore
const totalViolations = [
    { "ts": 1536050938, "violations_count": 120 },
    { "ts": 1536054538, "violations_count": 166 },
    { "ts": 1536058138, "violations_count": 169 },
    { "ts": 1536061738, "violations_count": 243 },
    { "ts": 1536065338, "violations_count": 319 },
    { "ts": 1536068938, "violations_count": 411 },
    { "ts": 1536072538, "violations_count": 431 },
    { "ts": 1536076138, "violations_count": 433 },
    { "ts": 1536079738, "violations_count": 464 },
    { "ts": 1536083338, "violations_count": 504 }
];

// @ts-ignore
const turnViolations = {
    "total_violators": 44,
    "total_non_violators": 77
};

// @ts-ignore
const recentViolations = [
    {
        "id": 136346,
        "violations": {
            "cutlane": {
                "timestamp": 1536051028
            },
            "wrongturn": {
                "timestamp": 1536051028,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051028
            },
            "trespass_zebra": {
                "timestamp": 1536051028
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full4.jpg",
        "ALPR_cropped_image": "/static/images/lpr4.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051028,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "889WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "905WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    },
    {
        "id": 136347,
        "violations": {
            "cutlane": {
                "timestamp": 1536051058
            },
            "wrongturn": {
                "timestamp": 1536051058,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051058
            },
            "trespass_zebra": {
                "timestamp": 1536051058
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full4.jpg",
        "ALPR_cropped_image": "/static/images/lpr4.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051058,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "815WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "609WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    },
    {
        "id": 136348,
        "violations": {
            "cutlane": {
                "timestamp": 1536051148
            },
            "wrongturn": {
                "timestamp": 1536051148,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051148
            },
            "trespass_zebra": {
                "timestamp": 1536051148
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full3.jpg",
        "ALPR_cropped_image": "/static/images/lpr3.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051148,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "368WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "172WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    },
    {
        "id": 136349,
        "violations": {
            "cutlane": {
                "timestamp": 1536051219
            },
            "wrongturn": {
                "timestamp": 1536051219,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051219
            },
            "trespass_zebra": {
                "timestamp": 1536051219
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full3.jpg",
        "ALPR_cropped_image": "/static/images/lpr3.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051219,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "128WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "475WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    },
    {
        "id": 136350,
        "violations": {
            "cutlane": {
                "timestamp": 1536051301
            },
            "wrongturn": {
                "timestamp": 1536051301,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051301
            },
            "trespass_zebra": {
                "timestamp": 1536051301
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full4.jpg",
        "ALPR_cropped_image": "/static/images/lpr4.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051301,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "290WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "213WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    },
    {
        "id": 136351,
        "violations": {
            "cutlane": {
                "timestamp": 1536051359
            },
            "wrongturn": {
                "timestamp": 1536051359,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051359
            },
            "trespass_zebra": {
                "timestamp": 1536051359
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full1.jpg",
        "ALPR_cropped_image": "/static/images/lpr1.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051359,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "881WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "704WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    },
    {
        "id": 136352,
        "violations": {
            "cutlane": {
                "timestamp": 1536051399
            },
            "wrongturn": {
                "timestamp": 1536051399,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051399
            },
            "trespass_zebra": {
                "timestamp": 1536051399
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full3.jpg",
        "ALPR_cropped_image": "/static/images/lpr3.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051399,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "891WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "750WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    },
    {
        "id": 136353,
        "violations": {
            "cutlane": {
                "timestamp": 1536051453
            },
            "wrongturn": {
                "timestamp": 1536051453,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051453
            },
            "trespass_zebra": {
                "timestamp": 1536051453
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full2.jpg",
        "ALPR_cropped_image": "/static/images/lpr2.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051453,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "994WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "660WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    },
    {
        "id": 136354,
        "violations": {
            "cutlane": {
                "timestamp": 1536051541
            },
            "wrongturn": {
                "timestamp": 1536051541,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051541
            },
            "trespass_zebra": {
                "timestamp": 1536051541
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full3.jpg",
        "ALPR_cropped_image": "/static/images/lpr3.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051541,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "783WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "744WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    },
    {
        "id": 136355,
        "violations": {
            "cutlane": {
                "timestamp": 1536051640
            },
            "wrongturn": {
                "timestamp": 1536051640,
                "turn_type": "E to E"
            },
            "runningredlight": {
                "timestamp": 1536051640
            },
            "trespass_zebra": {
                "timestamp": 1536051640
            }
        },
        "videos": [
            "/static/videos/vid1.mp4",
            "/static/videos/vid2.mp4"
        ],
        "ALPR_full_image": "/static/images/full2.jpg",
        "ALPR_cropped_image": "/static/images/lpr2.jpg",
        "ALPR": {
            "uuid": "",
            "regions_of_interest": [
                {
                    "height": 600,
                    "width": 600,
                    "y": 0,
                    "x": 0
                }
            ],
            "credits_monthly_used": 7040,
            "credit_cost": 2,
            "img_height": 600,
            "error": false,
            "epoch_time": 1536051640,
            "version": 2,
            "results": [
                {
                    "plate_index": 0,
                    "vehicle_region": {
                        "y": 7,
                        "width": 568,
                        "height": 568,
                        "x": 16
                    },
                    "processing_time_ms": 68.9315719604492,
                    "vehicle": {
                        "body_type": [
                            {
                                "name": "sedan-compact",
                                "confidence": 89.6389389038086
                            },
                            {
                                "name": "suv-standard",
                                "confidence": 2.92187452316284
                            },
                            {
                                "name": "sedan-wagon",
                                "confidence": 2.83985614776611
                            }
                        ],
                        "year": [
                            {
                                "confidence": 47.3032341003418,
                                "name": "2000-2004"
                            },
                            {
                                "name": "2005-2009",
                                "confidence": 39.6665573120117
                            },
                            {
                                "name": "1995-1999",
                                "confidence": 7.91491031646729
                            }
                        ],
                        "make_model": [
                            {
                                "confidence": 40.9104766845703,
                                "name": "chevrolet_hhr"
                            },
                            {
                                "name": "toyota_ist",
                                "confidence": 22.9741859436035
                            },
                            {
                                "confidence": 6.41662836074829,
                                "name": "chevrolet_trailblazer"
                            },
                            {
                                "confidence": 1.58923923969269,
                                "name": "mazda_verisa"
                            },
                            {
                                "confidence": 1.31779313087463,
                                "name": "nissan_micra"
                            },
                            {
                                "name": "mazda_tribute",
                                "confidence": 1.24455153942108
                            },
                            {
                                "confidence": 0.991917014122009,
                                "name": "chevrolet_uplander"
                            }
                        ],
                        "make": [
                            {
                                "confidence": 32.4275550842285,
                                "name": "chevrolet"
                            },
                            {
                                "name": "toyota",
                                "confidence": 31.9965953826904
                            },
                            {
                                "confidence": 15.4623928070068,
                                "name": "nissan"
                            },
                            {
                                "confidence": 8.25705337524414,
                                "name": "daihatsu"
                            },
                            {
                                "name": "mazda",
                                "confidence": 3.8371422290802
                            }
                        ],
                        "color": [
                            {
                                "name": "silver-gray",
                                "confidence": 73.2146682739258
                            },
                            {
                                "name": "blue",
                                "confidence": 15.9568424224854
                            }
                        ],
                        "orientation": [
                            {
                                "name": "180",
                                "confidence": 97.7202453613281
                            },
                            {
                                "confidence": 1.84529066085815,
                                "name": "225"
                            }
                        ]
                    },
                    "matches_template": 1,
                    "plate": "808WWI",
                    "requested_topn": 10,
                    "coordinates": [
                        {
                            "x": 237,
                            "y": 357
                        },
                        {
                            "y": 359,
                            "x": 364
                        },
                        {
                            "x": 362,
                            "y": 416
                        },
                        {
                            "x": 237,
                            "y": 414
                        }
                    ],
                    "region_confidence": 99,
                    "region": "wa",
                    "candidates": [
                        {
                            "matches_template": 1,
                            "confidence": 94.9990844726562,
                            "plate": "821WWI"
                        }
                    ],
                    "confidence": 94.9990844726562
                }
            ],
            "credits_monthly_total": 10000000000,
            "img_width": 600,
            "data_type": "alpr_results",
            "processing_time": {
                "total": 621.703000000025,
                "plates": 140.277725219727,
                "vehicles": 476.741000000004
            }
        }
    }
];


// WEBPACK FOOTER //
// ./src/dataTransformation/dashboard.ts